/* eslint-disable react/jsx-props-no-spreading, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BorderRandomizer from '../partials/BorderRandomizer';
import Image from '../partials/Image';
import PatchedLink from '../partials/PatchedLink';
import { borderTitle } from '../icons/borders';
import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/image-side-text.scss';

const propTypes = {
    id: PropTypes.number.isRequired,
    heading: PropTypes.string,
    image: AppPropTypes.image,
    imageUrl: PropTypes.string,
    imageCredit: PropTypes.string,
    links: PropTypes.array, // eslint-disable-line
    text: AppPropTypes.text,
    className: PropTypes.string,
};

const defaultProps = {
    heading: null,
    image: null,
    imageUrl: null,
    imageCredit: null,
    links: [],
    text: null,
    className: null,
};

const ImageSideTextBlock = ({
    id,
    heading,
    image,
    imageUrl,
    imageCredit,
    links,
    text,
    className,
}) => {
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <div className={styles.inner}>
                {image !== null ? (
                    <div className={styles.imageContainer}>
                        <Image
                            {...image}
                            credits={imageCredit}
                            imageUrl={imageUrl}
                            className={styles.image}
                        />
                    </div>
                ) : null}
                <div className={styles.textContainer}>
                    {heading !== null ? (
                        <div>
                            <BorderRandomizer
                                seed={heading}
                                borders={borderTitle}
                                // borderClassName={borderClassName}
                                className={styles.borderRandomizer}
                            />
                            <div
                                className={styles.heading}
                                dangerouslySetInnerHTML={{ __html: heading }}
                            />
                        </div>
                    ) : null}
                    <div className={styles.linksContainer}>
                        {links !== null
                            ? links
                                  .slice(0, 1)
                                  .map((link, i) => (
                                      <PatchedLink
                                          key={`link-first-${id}-${i + 1}`}
                                          url={link.url}
                                          label={link.label}
                                          backgroundClassName={styles.linkBackground}
                                          className={styles.link}
                                      />
                                  ))
                            : null}
                    </div>
                    {text !== null ? (
                        <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
                    ) : null}
                    <div className={styles.linksContainer}>
                        {links !== null
                            ? links
                                  .slice(1)
                                  .map((link, i) => (
                                      <PatchedLink
                                          key={`link-second-${id}-${i + 1}`}
                                          url={link.url}
                                          label={link.label}
                                          backgroundClassName={styles.linkBackground}
                                          className={styles.link}
                                      />
                                  ))
                            : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

ImageSideTextBlock.propTypes = propTypes;
ImageSideTextBlock.defaultProps = defaultProps;

export default ImageSideTextBlock;
